<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-11-20 14:16:19
-->
<template>
  <div class="page-contain" :class="language == 'zh_CN' ? '' : 'page-contain-us'">
    <div class="title">{{ $t("components.thirdPart.170720-0") }}</div>
    <!-- <div class="blank-contain">
      <div class="blanks"  :class="language== 'zh_CN'?'':'blanks-us'">
        <div class="tip1" :class="language== 'zh_CN'?'':'tip1-us'">Web3</div>
        <div class="tip2" :class="language== 'zh_CN'?'':'tip2-us'">{{ $t('components.thirdPart.170720-1') }}</div>
      </div>
      <div class="blanks" :class="language== 'zh_CN'?'':'blanks-us'">
        <div class="tip1" :class="language== 'zh_CN'?'':'tip1-us'">{{ $t('components.thirdPart.170720-2') }}</div>
        <div class="tip2" :class="language== 'zh_CN'?'':'tip2-us'">{{ $t('components.thirdPart.170720-3') }}</div>
      </div>
      <div class="blanks" :class="language== 'zh_CN'?'':'blanks-us'">
        <div class="tip1" :class="language== 'zh_CN'?'':'tip1-us'">{{ $t('components.thirdPart.170720-4') }}</div>
        <div class="tip2" :class="language== 'zh_CN'?'':'tip2-us'">{{ $t('components.thirdPart.170720-5') }}</div>
      </div>
    </div> -->
    <div class="blank-contain">
      <div class="card-card">
        <div class="card-icon-wrap">
          <img src="@/assets/img/iconLock@3x.png" alt="" class="card-icon" />
        </div>
        <div class="second-title">{{ $t("components.thirdPart.170720-6") }}</div>
        <div class="second-tip">{{ $t("components.thirdPart.170720-7") }}</div>
      </div>
      <div class="card-card">
        <div class="card-icon-wrap">
          <img src="@/assets/img/iconSafe@3x.png" alt="" class="card-icon" />
        </div>
        <div class="second-title">{{ $t("components.thirdPart.170720-8") }}</div>
        <div class="second-tip">{{ $t("components.thirdPart.170720-9") }}</div>
      </div>
      <div class="card-card">
        <div class="card-icon-wrap">
          <img src="@/assets/img/iconEfficient@3x.png" alt="" class="card-icon" />
        </div>
        <div class="second-title">{{ $t("components.thirdPart.170720-10") }}</div>
        <div class="second-tip">{{ $t("components.thirdPart.170720-11") }}</div>
      </div>
    </div>
    <div class="download-contain">
      <div class="download-inner">
        <div class="download-img-wrap">
          <img class="bg-img" src="@/assets/img/Pic5@3x.png" alt="" />
        </div>
        <div class="info-contain">
        <div class="info-title">{{ $t("components.thirdPart.170720-12") }}</div>
        <div class="info-tip">{{ $t("components.thirdPart.170720-13") }}</div>
        <div class="info-btn" :class="language == 'zh_CN' ? '' : 'info-btn-us'">
          <!-- Hover disabled, download functionality commented out -->
          <el-popover placement="bottom" title="" trigger="hover" content="" popper-class="poppers" :disabled="true">
            <div slot="reference" class="right-contain-tip3">
              <img src="@/assets/ios-icon02.png" class="btn-icon" alt="" />
              <div class="ios-btn">
                <div class="ios-title1">Download on the</div>
                <div class="ios-title2">App Store</div>
              </div>
            </div>
          </el-popover>
          <!-- Hover disabled, download functionality commented out -->
          <el-popover placement="bottom" title="" trigger="hover" content="" popper-class="poppers" :disabled="true">
            <div slot="reference" class="right-contain-tip4" style="margin-left: 16px">
              <img src="@/assets/goo@2x.png" class="btn-icon" alt="" />
              <div class="ios-btn">
                <div class="ios-title1">Download on the</div>
                <div class="ios-title2">Google Play</div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "thirdPart",
  props: {
    msg: String,
  },
  data() {
    return {
      acitve: 0,
      env: process.env.NODE_ENV,
      language: "en-US",
    };
  },
  mounted() {
    this.language = localStorage.getItem("bpHomeLanguage");
  },
  methods: {
    // 下载逻辑已注释
    // toDownload(type) {
    //   if (type == 1) {
    //     if (process.env.NODE_ENV == "production") location.href = "https://play.google.com/store/apps/details?id=com.bytelink.cregispay.card";
    //   } else if (type == 2) {
    //     if (process.env.NODE_ENV == "production") location.href = "https://www.pgyer.com/vtronceshi";
    //   } else {
    //     if (process.env.NODE_ENV == "production") {
    //       location.href = "https://file.vcard-usa.com/app/vtron.apk";
    //     } else {
    //       location.href = "https://file.vcard-usa.com/app/vtron.apk";
    //     }
    //   }
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-popover .el-popper .poppers {
  min-width: 135px !important;
  width: 135px !important;
  padding: 0;
}
</style>
<style src="./thirdPartCss/max.css" scoped></style>
<style src="./thirdPartCss/middle.css" scoped></style>
<style src="./thirdPartCss/flat.css" scoped></style>
<style src="./thirdPartCss/min.css" scoped></style>
